// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__qtW9E","fileBtn":"File_fileBtn__15ilj","closeBtn":"File_closeBtn__2BWaU","fileSelected":"File_fileSelected__3qKzV","disabled":"File_disabled__6LPjG"};